import { observer } from "mobx-react-lite";
import { runInAction } from "mobx";
import { useOrderFormState } from "@boundary/_hooks/useOrderFormState";
import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { ServiceOption } from "@boundary/components/serviceOption";
import { useDebouncedPriceCalculation } from "@boundary/_hooks/useDebouncedPriceCalculation";
import styles from "./formatSelect.module.scss";

interface FormatSelectProps {
  vm: ReturnType<typeof useOrderFormState>;
}

export const FormatSelect = observer(function FormatSelect({ vm }: FormatSelectProps) {
  if (!vm.currentFile || !vm.currentService) return null;
  if (!vm.currentFile.id || !vm.currentFile.previewUrl) return null;

  const file = vm.currentFile;
  const types = getInfoByService(vm.currentService.type).formatOptions;
  const calculatePrice = useDebouncedPriceCalculation(vm);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Формат</h2>
      <div className={styles.options}>
        {types.map((type, index) => (
          <ServiceOption
            key={index}
            value={type === file.formatType}
            onChange={() => {
              runInAction(() => {
                file.formatType = type;
              });
              calculatePrice();
            }}
          >
            {type}
          </ServiceOption>
        ))}
      </div>
    </div>
  );
});

